export default {
  pages: [
    {
      parent: {
        slug: '', title: 'Home', name: 'MyHome'
      }
    },
    {
      parent: {
        slug: 'our-business', title: 'Our business', name: 'MyBusiness'
      },
      children: [
        { slug: 'ceo-intro', title: 'CEO‘s introduction', name: 'MyBusinessCeo' },
        { slug: 'our-performance', title: 'Our performance', name: 'MyBusinessPerformance' },
        { slug: 'vision-values', title: 'Vision & values', name: 'MyBusinessVision' },
        { slug: 'operations', title: 'Our operations', name: 'MyBusinessOperations' },
        { slug: 'people-awards', title: 'People & awards', name: 'MyBusinessPeople' }
      ]
    },
    {
      parent: {
        slug: 'focus-areas', title: 'Focus areas', name: 'MyFocus', shared: true
      },
      children: [
        { slug: 'safety', title: 'Safety', name: 'MyFocusSafety' },
        { slug: 'network-reliability', title: 'Network reliability', name: 'MyFocusNetwork' },
        { slug: 'customer-satisfaction', title: 'Customer satisfaction', name: 'MyFocusCustomer' },
        { slug: 'value-for-money', title: 'Value for money', name: 'MyFocusValue' },
        { slug: 'corporate-social-responsibility', title: 'Corporate social responsibility', name: 'MyFocusCsr' },
        { slug: 'environment', title: 'Environment', name: 'MyFocusEnvironment' },
        { slug: 'stakeholder-engagement', title: 'Stakeholder engagement', name: 'MyFocusStake' },
        { slug: 'innovation', title: 'Innovation', name: 'MyFocusInnovation' },
        { slug: 'low-carbon', title: 'Low carbon', name: 'MyFocusCarbon' }
      ]
    },
    {
      parent: {
        slug: 'future-energy', title: 'Future energy', name: 'MyFuture'
      },
      children: [
        { slug: 'landscape', title: 'Future energy landscape', name: 'MyFutureLandscape', color: 'petrol' },
        { slug: 'explore-day', title: 'Explore a day', name: 'MyFutureExplore', color: 'brown' }
      ]
    },
    {
      parent: {
        slug: 'financials', title: 'Financials', name: 'MyFinancials'
      }
    },
    {
      parent: {
        slug: 'governance', title: 'Governance', name: 'MyGovernance'
      },
      children: [
        { slug: 'transparency', title: 'Transparency', name: 'MyGovernanceTransparency' },
        { slug: 'resilience', title: 'Organisational resilience', name: 'MyGovernanceResilience' },
        { slug: 'board-directors', title: 'Board of Directors', name: 'MyGovernanceBoard' },
        { slug: 'executive-management-team', title: 'Executive Management Team', name: 'MyGovernanceExecutive' }
      ]
    },
    {
      parent: {
        slug: 'ukpn-services', title: 'UK Power Networks Services', name: 'MyServices'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/pages.js